import { useLocation } from 'react-router-dom';
import { Link } from '~/utils/navigation';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { motion } from 'motion/react';

import { insertTrackEvent } from '@comeon/analytics';

import { selectOneBankIDFlowEnabled, selectOneButtonFlow } from '~/components/brand/ducks/selectors';
import { ROUTE_LOGIN } from '~/components/router/constants';
import useTranslations from '~/components/translation/use-translations';
import useConfiguration from '~/configuration/use-configuration';
import useLoginFlow from '~/hooks/use-login-flow';
import breakpoint from '~/utils/style-utils';

const TEXT_KEYS = ['MOBILE_PLAY_NOW', 'MOBILE_LOGIN_LOGIN_BUTTON'];

const Effect = props => {
	return (
		<motion.span whileTap={{ scale: 0.9 }}>
			<Link {...props}>{props.children}</Link>
		</motion.span>
	);
};

const StyledLoginLink = styled(Effect)`
	color: var(--page-head-link, rgba(var(--base-02), 1));
	font: var(--top-right-corner-link, var(--label-regular));
	padding-left: var(--top-right-corner-link-padding, 24px);
	margin-left: var(--top-right-corner-link-margin-left, 0);
	white-space: nowrap;
	position: relative;

	${breakpoint.md`
		margin-left: 0;
	`};
`;

const dataLayerLoginEvent = () => {
	insertTrackEvent({
		category: 'Login',
		action: 'Click - Log-In',
		label: 'Menu'
	});
};

const LoginLink = () => {
	const oneBankIDFlowEnabled = useSelector(selectOneBankIDFlowEnabled);
	const oneButtonFlow = useSelector(selectOneButtonFlow);
	const { translations, isTranslationsLoading } = useTranslations(TEXT_KEYS);
	const { showLoginAsGuestOption, useTrustlyLogin, isDesktop } = useConfiguration();

	const loadTrustlyOnSidebar = isDesktop && useTrustlyLogin && !showLoginAsGuestOption;
	const { initializeLogin } = useLoginFlow();

	const location = useLocation();
	const handleLogin = e => {
		e.preventDefault();
		e.stopPropagation();
		initializeLogin({
			from: location
		});
		dataLayerLoginEvent();
	};

	const text = isTranslationsLoading
		? ''
		: translations[oneBankIDFlowEnabled || oneButtonFlow ? 'MOBILE_PLAY_NOW' : 'MOBILE_LOGIN_LOGIN_BUTTON'];

	return (
		<StyledLoginLink
			data-at="login-header"
			as={loadTrustlyOnSidebar ? 'button' : null}
			href={ROUTE_LOGIN}
			onClick={handleLogin}
		>
			{text}
		</StyledLoginLink>
	);
};

export default LoginLink;
